import QTable from 'quasar/src/components/table/QTable.js';

export function getTicketDashboardTableColumn(): QTable['columns'] {
  return [
    {
      name: 'title',
      label: 'عنوان تیکت',
      field: 'title',
      align: 'left',
      style: 'max-width:200px'
    },
    {
      name: 'status',
      label: 'وضعیت',
      field: 'status',
      align: 'left',
      style: 'max-width:90px;min-width:50px'
    },
    {
      name: 'last_answer_date',
      field: 'last_answer_date',
      label: 'آخرین پاسخ',
      align: 'center'
    },
    {
      name: 'actions',
      field: 'actions',
      label: '',
      align: 'left'
    }
  ]
}